var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "my-carousel",
    {
      ref: "home_news",
      attrs: {
        "per-page-custom": [
          [0, 1],
          [768, 2],
          [991, 2],
          [1100, 3],
          [1200, 4]
        ],
        "pagination-enabled": true,
        "scroll-per-page": true,
        "navigation-enabled": true,
        "navigation-next-label": "<span></span>",
        "navigation-prev-label": "<span></span>"
      }
    },
    _vm._l(_vm.news, function(item, key) {
      return _c("slide", { key: key }, [
        _vm.config.template == 1
          ? _c("div", { staticClass: "carousel-card d-flex flex-column" }, [
              _c("div", [_c("h4", [_vm._v(_vm._s(item.title))])]),
              _vm._v(" "),
              _c("div", { domProps: { innerHTML: _vm._s(item.description) } }),
              _vm._v(" "),
              _c("div", { staticClass: "mt-auto" }, [
                _c("a", { attrs: { href: item.url_href, target: "_blank" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.lang.news.more) +
                      "\n                "
                  )
                ])
              ])
            ])
          : _vm.config.template == 2
          ? _c("div", { staticClass: "carousel-card d-flex flex-column" }, [
              _c("div", { staticClass: "mx-auto" }, [
                _c("img", {
                  staticClass: "card-news mx-auto d-block",
                  attrs: { src: item.img_url, alt: item.title }
                })
              ]),
              _vm._v(" "),
              _c("div", [_c("h4", [_vm._v(_vm._s(item.title))])]),
              _vm._v(" "),
              _c("div", { domProps: { innerHTML: _vm._s(item.description) } }),
              _vm._v(" "),
              _c("div", { staticClass: "mt-auto" }, [
                _c("a", { attrs: { href: item.url_href, target: "_blank" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.lang.news.more) +
                      "\n                "
                  )
                ])
              ])
            ])
          : _vm.config.template == 3
          ? _c("div", { staticClass: "carousel-card d-flex flex-column" }, [
              _c("div", { staticClass: "img" }, [
                _c("img", {
                  staticClass: "card-news mx-auto d-block",
                  attrs: { src: item.img_url, alt: item.title }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "title" }, [
                _c("h4", [_vm._v(_vm._s(item.title))])
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "description",
                domProps: { innerHTML: _vm._s(item.description) }
              }),
              _vm._v(" "),
              item.options.length
                ? _c(
                    "div",
                    { staticClass: "subdescription" },
                    _vm._l(item.options, function(option) {
                      return _c("div", { class: _vm.option_classes[key] }, [
                        option.is_public && _vm.isValidURL(option.url)
                          ? _c(
                              "a",
                              { attrs: { href: option.url, target: "blank" } },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(option.title) +
                                    "\n                    "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    }),
                    0
                  )
                : _vm._e()
            ])
          : _vm._e()
      ])
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }